"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pill = Pill;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TabFocusTrap = _interopRequireDefault(require("../TabFocusTrap"));

var styles = {
  "Pill": "Pill__Pill___2yQFD a11y__focus-outline--default___2hwb1",
  "Pill__label": "Pill__Pill__label____EsBZ",
  "Pill__close-button": "Pill__Pill__close-button___3OlnQ a11y__focus-outline--default___2hwb1",
  "Pill__drag-icon": "Pill__Pill__drag-icon___2aB1g",
  "Pill__icon": "Pill__Pill__icon___1NILR"
};

function Pill(_ref) {
  var label = _ref.label,
      onClose = _ref.onClose,
      testId = _ref.testId,
      onDrag = _ref.onDrag,
      className = _ref.className,
      dragHandleComponent = _ref.dragHandleComponent,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["label", "onClose", "testId", "onDrag", "className", "dragHandleComponent"]);
  var classNames = (0, _classnames["default"])(styles.Pill, className);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: classNames,
    "data-test-id": testId
  }, otherProps, {
    onDrag: onDrag
  }), onDrag && (dragHandleComponent ? dragHandleComponent : /*#__PURE__*/_react["default"].createElement("span", {
    className: styles['Pill__drag-icon']
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "Drag",
    color: "muted",
    className: styles.Pill__icon
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    "aria-label": label,
    title: label,
    className: styles.Pill__label
  }, label), onClose && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    "aria-label": "close",
    onClick: onClose,
    className: styles['Pill__close-button']
  }, /*#__PURE__*/_react["default"].createElement(_TabFocusTrap["default"], null, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "Close",
    color: "muted",
    className: styles.Pill__icon
  }))));
}

Pill.defaultProps = {
  testId: 'cf-ui-pill'
};
var _default = Pill;
exports["default"] = _default;